import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TabGroup = memo(({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-300">
      <div className="flex gap-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={classNames(
              'px-4 py-2 text-sm font-medium transition-all',
              {
                'border-b-2 border-blue-03 text-blue-03': activeTab === tab.id,
                'text-gray-500 hover:text-blue-03': activeTab !== tab.id,
              }
            )}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
});

TabGroup.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default TabGroup; 